// @core/api/endpoints/team/accept_team_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AcceptTeamInvitationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Accept team invitation
 * Accepts a pending team invitation. The user becomes a member of the team with the role specified in the invitation.
 */
export async function AcceptTeamInvitation(
  invitation_id: string,
  data: AcceptTeamInvitationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invitations/:invitation_id/accept`;
  requestPath = requestPath.replace(':invitation_id', encodeURIComponent(invitation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
